var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "199px",
    height: "199px",
    viewBox: "0 0 199 199",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.428257,56.5691665 C140.333598,54.4769445 136.773918,54.4769445 134.47045,56.5691665 L99.4996261,91.4992939 L64.5288017,56.5691665 C62.4341421,54.4769445 58.8744622,54.4769445 56.5709947,56.5691665 C54.4763351,58.6613885 54.4763351,62.2169259 56.5709947,64.5177127 L91.541819,99.4478401 L56.5709947,134.377968 C54.4763351,136.47019 54.4763351,140.025727 56.5709947,142.326514 C57.6183245,143.372625 59.0834196,144 60.5500852,144 C62.0167508,144 63.4816963,143.372625 64.5291757,142.326514 L99.5,107.396386 L134.470824,142.326514 C135.518154,143.372625 136.983249,144 138.449915,144 C139.91658,144 141.381526,143.372625 142.429005,142.326514 C144.523665,140.234292 144.523665,136.678754 142.429005,134.377968 L107.458181,99.4478401 L142.429005,64.5177127 C144.522207,62.4254907 144.522207,58.8699533 142.429005,56.5691665 L142.428257,56.5691665 Z",
    id: "Path",
    fill: "#842029"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5,0 C44.6178947,0 0,44.6178947 0,99.5 C0,154.382105 44.6178947,199 99.5,199 C154.382105,199 199,154.382105 199,99.5 C199,44.6178947 154.382105,0 99.5,0 Z M99.5,187.897895 C50.6926316,187.897895 11.1021053,148.307368 11.1021053,99.5 C11.1021053,50.6926316 50.6926316,11.1021053 99.5,11.1021053 C148.307368,11.1021053 187.897895,50.6926316 187.897895,99.5 C187.897895,148.307368 148.307368,187.897895 99.5,187.897895 Z",
    id: "Shape",
    fill: "#F8D7DA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconRed);
export default __webpack_public_path__ + "static/media/error-icon--red.d5812765cdfd32d0d55ef41132c48f0d.svg";
export { ForwardRef as ReactComponent };